import {suffixTestId, TestIdProps} from 'shared/web';

export interface DropdownDividerProps extends TestIdProps {}

export function DropdownDivider(props: DropdownDividerProps) {
  return (
    <hr
      className="my-2 text-[var(--color-separator)]"
      data-testid={suffixTestId('dropdownDivider', props)}
    />
  );
}
